import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Box, ThemeProvider, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore, } from '@mcn-platform/models';
import { portalTheme } from '@mcn-platform/converse-lib';
import AppBar from '../nav/AppBar';
import FooterBar from '../nav/FooterBar';
import InstructorDetail from './InstructorDetail';
const limitToPageWidth = true;
const InstructorsPage = () => {
    const { status } = useStore();
    const { instructorID } = useParams();
    if (status !== 'ready') {
        return null;
    }
    return (_jsx(ThemeProvider, { theme: portalTheme, children: _jsxs(Box, { sx: {
                ...(limitToPageWidth && {
                    width: '100%',
                    maxWidth: 1200,
                    marginX: 'auto',
                }),
            }, children: [_jsx(AppBar, {}), _jsx(InstructorDetail, { instructorID: instructorID }), _jsx(FooterBar, {})] }) }));
};
export default observer(InstructorsPage);
//# sourceMappingURL=InstructorPage.js.map